

import { useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import {  toast } from "react-toastify";

import { useNavigate } from "react-router-dom";
import { loginSuccessSensor } from "../redux/slices/singleSensorSlice";
import { loginSuccessAllSens } from "../redux/slices/allSensorSlice";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import apiService from "../api/ApiService";
import { useForm } from "react-hook-form";
import { isEqual } from "./EditModalDam";
import { Close, Code, DateRange, Details, ModelTraining, Sell } from "@mui/icons-material";
const moment=require('moment-jalaali');


const EditSens=({penr})=>{
    const {currentSensors}=useSelector(state=>state.sensors)
    const [valid,setValid]=useState(false)
    const {openModalls,isOpenModal,closeModalls}=useGlobalContext();
    const mainProp={
        specs:penr?.specs,deviceCode:penr?.deviceCode,createAt:penr?.createAt,version:penr?.version,necklaceNumber:penr?.necklaceNumber
      }
    const dispatch=useDispatch();
    const {watch,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({defaultValues:mainProp});
   

    const updatePen=async(data)=>{           
                
                   
                const data1=JSON.stringify({
                    ...data
                })
                const res=await apiService.updateSensor(penr.id,data1);
                const filter=currentSensors.filter(item=>{
                    return item.id!==res.data.id
                })
                dispatch(loginSuccessAllSens([...filter,res.data]))
                dispatch(loginSuccessSensor(res.data))
                openModalls()
                
    }
    const allData=watch()
    
    useEffect(()=>{setValid(isEqual(mainProp,allData))},[allData])
    return <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <form onSubmit={handleSubmit(updatePen)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <DriveFileRenameOutlineIcon fontSize="large"/>

            <h4 >به روز رسانی سنسور</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("deviceCode",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Code fontSize="small"/> کد سنسور</label>
            {errors?.deviceCode?.message&&<span className='errMsg'>{errors.deviceCode.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("specs",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Details fontSize="small"/> مشخصات سنسور</label>
            {errors?.specs?.message&&<span className='errMsg'>{errors.specs.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder=                          "2024-01-26T17:55:38.006Z"
 {...register("createAt",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><DateRange fontSize="small"/> زمان ایجاد سنسور</label>
            {errors?.createAt?.message&&<span className='errMsg'>{errors.createAt.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("necklaceNumber",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Sell fontSize="small"/> شماره گردنبند  </label>
            {errors?.necklaceNumber?.message&&<span className='errMsg'>{errors.necklaceNumber.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("version",{required:'این مقدار ضروری است',pattern:{
                value:/^.{1,50}$/,
                message:'    حداکثر 50 کاراکتر'
            }})}/>
            <label for="" className={'labelSS'}><ModelTraining fontSize="small"/> ورژن   </label>
            {errors?.version?.message&&<span className='errMsg'>{errors.version.message}</span>}
        </div>
        <button disabled={valid} className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'220px'}}> 
        
        </div>
        
    </div>
}
export default EditSens